// extracted by mini-css-extract-plugin
export default {"button":"xv","primary":"yv","fullWidth":"zv","secondary":"Av","nutrition":"Bv","underlined":"Cv","small":"Ev","medium":"Fv","info":"Gv","white":"Hv","border":"Iv","mango":"Jv","charcoal":"Kv","court":"Lv","green":"Mv","spark":"Nv","linkButton":"Ov","disabled":"Pv"};
    if(module.hot) {
      // 1726593103466
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  